// extracted by mini-css-extract-plugin
module.exports = {"button":"NextButton_button__fR9VW","inactive":"NextButton_inactive__DMdfi"};